export default __webpack_public_path__ + "static/media/runkeeper-devices.76a7e96d.png";